import React from 'react'
import Heading from '../Components/Heading/Heading';
import Card from '../Components/Routen/Card'
import reisen from '../data/reisen.json'

function Reiseberichte() {
    const entries = reisen.sort((a, b) => a.id - b.id).reverse();
    return (
        <div>
            <Heading>Reiseberichte</Heading>
            <div className='text-stone-700 dark:text-stone-300 font-text text-lg mb-6'>Hier findest du eine Übersicht über meine bisherigen Reisen mit teils spannenden Reiseberichten und tollen Fotos.</div>
            <div className='grid gap-8' style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(18rem, 1fr)' }}>
                {entries.map(reise => <Card key={reise.id} {...reise} />)}
            </div>
        </div>
    )
}

export default Reiseberichte
